/*
 * Northsheep — "See how we measure" inside a FAQ answer.
 *
 * Opens the size-guide popup that main-product already renders, rather than
 * building a second one. One drawing, one set of measuring lines, one place to
 * change them.
 *
 * The button ships with `hidden` on it and is revealed here, only once the
 * popup has been found. The FAQ section can sit on a page with no product at
 * all, and a link that opens nothing is worse than no link — the answer reads
 * correctly either way.
 *
 * The popup is found at CLICK time as well, not cached at load: Dawn re-renders
 * the variant picker on every variant change, and a stale reference to anything
 * inside the buy box is the oldest trap in this theme. The <modal-dialog> is
 * outside it, but this costs one querySelector and removes the question.
 */
(function () {
  var SEL = 'modal-dialog[id^="NsSizeGuide-"]';

  function guide() {
    return document.querySelector(SEL);
  }

  function init() {
    var buttons = document.querySelectorAll('[data-ns-faq-guide]');
    if (!buttons.length || !guide()) return;

    buttons.forEach(function (button) {
      button.hidden = false;
      button.addEventListener('click', function () {
        var dialog = guide();
        /* show() is Dawn's own; it takes the opener so focus returns here on
           close. If the element has not upgraded yet (global.js is deferred and
           a fast tap can beat it), there is nothing sensible to do but wait for
           the next one. */
        if (dialog && typeof dialog.show === 'function') dialog.show(button);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
